import React, { useContext } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { getAppConfiguration } from '../../Config';
import { UserContext } from '../../Context/UserContext/UserContext';

export const RichTextEditor = (props: {
  disabled?: boolean;
  className?: string;
  value: string;
  onChange: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  overrideConfig?: Record<string, any>;
}) => {
  const user = useContext(UserContext);
  const getLanguageCode = () => {
    if (user.locale === 'sv') {
      return 'sv-SE';
    }

    return undefined;
  };

  const config = {
    height: 400,
    menubar: false,
    branding: false,
    theme: 'silver',
    skin: 'CUSTOM',
    skin_url: `${process.env.PUBLIC_URL}/tinymce/skins/ui/CUSTOM`,
    mobile: {
      theme: 'silver',
      plugins: ['autosave', 'lists', 'autolink', 'link'],
      toolbar: 'undo redo | bold italic link removeformat | bullist numlist  ',
      contextmenu: 'link',
      link_default_target: '_blank',
    },
    // plugins: [
    //   'advlist autolink lists link charmap print preview anchor',
    //   'searchreplace visualblocks code fullscreen',
    //   'insertdatetime table paste code',
    // ],
      //  plugins: [
      //       'advlist', 'autolink', 'lists', 'link','preview', 'image','print', 'charmap',
      //       'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
      //       'insertdatetime','paste', 'media', 'table', 'help', 'wordcount',
      //     ],
       plugins: [
            'advlist', 'autolink', 'lists', 'link','preview', 'image', 'charmap',
            'anchor', 'searchreplace', 'visualblocks', 'fullscreen',
            'insertdatetime', 'media', 'table', 'help', 'wordcount',
          ],
          // toolbar: 'undo redo | blocks | ' +
          //   'bold italic forecolor | alignleft aligncenter ' +
          //   'alignright alignjustify | bullist numlist outdent indent | ' +
          //   'removeformat | help',
    toolbar_mode: 'floating',
    contextmenu: 'link',
    link_context_toolbar: true,
    link_title: true,
    default_link_target: '_blank',
    link_default_target: '_blank',
    link_assume_external_targets: true,
    toolbar: 'undo redo | bold italic link removeformat | bullist numlist | help',
    browser_spellcheck: true,
    language: getLanguageCode(),
    urlconverter_callback: function (url: string) {
      if (!url.startsWith('http')) {
        if (url.indexOf('.') > -1) {
          return `http://${url}`;
        }
      }
      return url;
    },
  } as Record<string, any>;

  const init = props.overrideConfig ? { ...config, ...props.overrideConfig } : config;
  const apiKey = getAppConfiguration().tinyMCEApiKey;
  return (
    <Editor
    disabled={props.disabled}
      init={init}
      value={props.value}
      onEditorChange={props.onChange}
      apiKey={apiKey}
      onFocus={() => props.onFocus && props.onFocus()}
      onBlur={() => props.onBlur && props.onBlur()}
    />
  );
};
